<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('type')">
                            <parameter-selectbox code="identity_card_types" v-model="form.type"
                                                 :validateError="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="email" rules="email" v-slot="{valid, errors}">
                        <b-form-group :label="$t('email')">
                            <b-form-input
                                :state="errors[0] ? false : (valid ? true : null)"
                                v-model="form.email"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]"
                                                     v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('name')">
                            <b-form-input :validate-error="errors[0]" v-model="form.name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="surname" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('surname')">
                            <b-form-input :validate-error="errors[0]" v-model="form.surname">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="national_id" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('national_id')">
                            <b-form-input v-model="form.national_id"
                                          :state="errors[0] ? false : null" />
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="registration_number" rules="" v-slot="{ errors }">
                        <b-form-group :label="$t('registration_number')">
                            <b-form-input v-model="form.registration_number"
                                          :state="errors[0] ? false : null" />
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="birthdate"
                                        rules=""
                                        v-slot="{valid, errors}">
                        <b-form-group :label="$t('date_of_birth')">
                            <select-date v-model="form.birthdate"
                                         :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="birthplace" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('birthplace')">
                            <b-form-input v-model="form.birthplace"
                                          :class="errors[0] ? 'is-invalid':''">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="title" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('title1')">
                            <b-form-input :validate-error="errors[0]" v-model="form.title"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="company" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('corporation')">
                            <b-form-input :validate-error="errors[0]" v-model="form.company"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="unit" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('unit')">
                            <b-form-input :validate-error="errors[0]" v-model="form.unit"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="position" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('position')">
                            <b-form-input :validate-error="errors[0]" v-model="form.position"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="valid_date"
                                        rules=""
                                        v-slot="{valid, errors}">
                        <b-form-group :label="$t('valid_date')">
                            <select-date v-model="form.valid_date"
                                         :validation-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="file" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="form.file ? form.file.name : (file ? file.name : $t('select_file'))"
                                             :drop-placeholder="$t('drop_file')"
                                             accept="image/jpeg, image/png, image/gif"
                                             ref="fileInput"
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import IdentityCardService from "@/services/IdentityCardService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,

        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                file: null,
                form: {
                    type: null,
                    email: null,
                    name: null,
                    surname: null,
                    national_id: null,
                    registration_number: null,
                    birthdate: null,
                    birthplace: null,
                    title: null,
                    company: null,
                    unit: null,
                    position: null,
                    valid_date: null,
                    file: null,
                }
            }
        },
         created() {
             this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                IdentityCardService.get(id)
                               .then((response) => {
                                  const data = response.data.data;
                                  this.form = {
                                    ...data,
                                    file: null,
                                  };
                                  this.file = data.file;
                                  this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;

                    let formData = new FormData();
                    formData.append('type', this.form.type)
                    if (this.form.email){
                        formData.append('email', this.form.email)

                    }
                    formData.append('name', this.form.name)
                    formData.append('surname', this.form.surname)
                    formData.append('national_id', this.form.national_id)
                    formData.append('registration_number', this.form.registration_number)
                    formData.append('birthplace', this.form.birthplace)
                    formData.append('title', this.form.title)
                    formData.append('unit', this.form.unit)
                    formData.append('position', this.form.position)
                    formData.append('_method', 'PUT')
                    if(this.form.company) {
                        formData.append('company', this.form.company)
                    }
                    if(this.form.birthdate) {
                        formData.append('birthdate', this.form.birthdate)
                    }
                    if(this.form.valid_date) {
                        formData.append('valid_date', this.form.valid_date)
                    }
                    if(this.form.file) {
                        formData.append('file', this.form.file)
                    }
                    if(this.form.email) {
                        formData.append('email', this.form.email)
                    }
                    if(this.form.type) {
                        formData.append('type', this.form.type)
                    }
                    if(this.form.birthdate) {
                        formData.append('birthdate', this.form.birthdate)
                    }
                    if(this.form.valid_date) {
                        formData.append('valid_date', this.form.valid_date)
                    }

                    IdentityCardService.update(this.formId, formData)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            }
        }
    }
</script>
